module.exports = __webpack_public_path__ + "img/retweet-solid.37365966.svg";